import { tv } from 'tailwind-variants'

export const bodyWrapperVariants = tv({
  slots: {
    bodyWrapper: 'flex flex-row max-w-[1440px] mt-[90px] w-full h-[calc(100%-88px)] p-deca'
  }
})
